document.querySelectorAll('.country-select').forEach(form => {
  const button = form.querySelector('.country-select__button');
  const panel = form.querySelector('.country-select__panel');
  const searchInput = form.querySelector('.country-select__search');
  const options = Array.from(form.querySelectorAll('.country-select__option'));
  const hiddenInput = form.querySelector('.country-select__input');

  let focusIndex = -1;

  // Toggle panel
  button.addEventListener('click', () => {
    const isHidden = panel.hidden;
    panel.hidden = !isHidden;
    button.setAttribute('aria-expanded', String(!isHidden));
    if (!panel.hidden) searchInput.focus();
  });

  // Close on outside click
  document.addEventListener('click', e => {
    if (!form.contains(e.target)) {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      focusIndex = -1;
    }
  });

  // Keyboard navigation
  form.addEventListener('keydown', e => {
    if (panel.hidden) return;

    if (e.key === 'Escape') {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.focus();
      focusIndex = -1;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      focusIndex = (focusIndex + 1) % options.length;
      options[focusIndex].focus();
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      focusIndex = (focusIndex - 1 + options.length) % options.length;
      options[focusIndex].focus();
    }

    if (e.key === 'Enter' && focusIndex > -1) {
      e.preventDefault();
      options[focusIndex].click();
    }
  });

  // Filter options
  searchInput.addEventListener('input', () => {
    const query = searchInput.value.toLowerCase();
    options.forEach(option => {
      const name = option.dataset.countryName;
      option.closest('li').hidden = !name.includes(query);
    });
  });

  // Select country
  options.forEach(option => {
    option.addEventListener('click', () => {
      hiddenInput.value = option.dataset.countryCode;
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      form.submit();
    });
  });
});